import './lib/magnific.js';

const portland = portland || {};

(function ($) {

	portland.article = {

		elem: {
			$illustrations: $('.illustration'),
			$linkGallery: $('.image-gallery'),
			$linkVideo: $('.video__link')
		},

		mql: {
			large: window.matchMedia('(min-width: 640px)'),
			mobile: window.matchMedia('(max-width: 639px)')
		},

		init: function () {
			this.bindUIActions();
			this.captionHeights();
		},

		bindUIActions: function () {

			this.elem.$linkGallery.magnificPopup({ 
				delegate: 'a.image-gallery__link', // the selector for gallery item
				type: 'image',
				image: {
					titleSrc: function(item) {
						return $(item.el.attr('data-caption'))[0].innerHTML;
					},
					verticalFit: false
				},
				gallery: {
					enabled: true,
					arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><svg class="icon icon-arrow-right" focusable="false"><use xlink:href="#icon-arrow-right"></use></svg></button>',
					tCounter: '<span class="mfp-counter">%curr%/%total%</span>'
				},
				closeMarkup: '<button title="%title%" type="button" class="mfp-close"><svg class="icon icon-close" focusable="false"><use xlink:href="#icon-close"></use></svg></button>',
				callbacks: {
					afterChange: function() {
						setTimeout(function() {
							$('.mfp-arrow').removeAttr('style');
							if(portland.article.mql.mobile.matches) {
								$('.mfp-arrow').css('top',($('.mfp-img').height() + 100) + 'px');
							}
						}, 10);
					},
					resize: function() {
						setTimeout(function() {
							$('.mfp-arrow').removeAttr('style');
							if(portland.article.mql.mobile.matches) {
								$('.mfp-arrow').css('top',($('.mfp-img').height() + 100) + 'px');
							}
						}, 10);
					}
				}
			});

			this.elem.$linkVideo.magnificPopup({ 
				type: 'iframe',
				iframe: {
					markup: '<div class="mfp-iframe-scaler">' +
						'<div class="mfp-close"></div>' +
						'<iframe src="//about:blank" class="mfp-iframe" frameborder="0" allow="autoplay" allowfullscreen></iframe>' +
						'</div>',
					patterns: {
						youtube: {
							index: 'youtube.com/',
							id: 'v=',
							src: 'https://www.youtube.com/embed/%id%?autoplay=1&enablejsapi=1&rel=0'
						}
					}
				},
				closeMarkup: '<button title="%title%" type="button" class="mfp-close"><svg class="icon icon-close" focusable="false"><use xlink:href="#icon-close"></use></svg></button>'
			});

			$(window).on('resize', this.captionHeights.bind(this));

		},

		captionHeights: function() {
			portland.article.elem.$illustrations.each( function() {
				portland.article.equalizeHeights($(this).find('.illustration__caption'));
			});
		},

		equalizeHeights: function(selector) {
			selector.removeAttr('style');
			if (portland.article.mql.large.matches) {
				let tallest = 0;
				selector.each(function() {
					if ($(this).innerHeight() > tallest) {
						tallest = $(this).innerHeight();
					}
				});
				selector.innerHeight(tallest);
			};
		}

	};

}(window.jQuery));

const ready = () => {
	portland.article.init();
};

window.addEventListener('DOMContentLoaded', ready, false);
$(document).foundation();
